import React, { useEffect, useState } from 'react';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import SvgTagEdit from '@components/ringil3/icons/TagEdit.tsx';
import { FieldLabel } from '@components/framework/formfield/FieldLabel.tsx';
import RichTextEditor from '@components/RingilComponents/RichTextEditor/RichTextEditor.tsx';
import SafeHtml from '@components/RingilComponents/RichTextEditor/SafeHtml.tsx';
import { NOTE_SOFT_LIMIT } from '@components/RingilComponents/RichTextEditor/constants.ts';

interface ComponentProps {
  secured?: SecuredConfig;
  label: string;
  value?: string;
  onChange: (value: string) => void;
  icon?: React.ReactElement;
  readOnly?: boolean;
  fullWidth?: boolean;
  dataTestId?: string;
}

const RichNoteTag: React.FC<ComponentProps> = ({ secured, label, value, onChange, icon, readOnly, fullWidth, dataTestId }) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => setInternalValue(value), [value]);

  const pane = () => {
    return (
      <div className="flex flex-col gap-1">
        {label && <FieldLabel label={label} />}
        <RichTextEditor value={internalValue} onChange={setInternalValue} maxLength={NOTE_SOFT_LIMIT} allowCodeBlock={false} autoFocus />
      </div>
    );
  };

  return (
    <ButtonTag
      secured={secured}
      label={label}
      icon={icon}
      value={value ? <SafeHtml html={value} dataTestId={dataTestId ? `${dataTestId}Value` : undefined} /> : ''}
      actionIcon={<SvgTagEdit />}
      actionPane={pane()}
      onSave={onSuccess => {
        onChange(internalValue);
        onSuccess();
      }}
      readonly={readOnly}
      autoClose
      popupWidth={'527px'}
      className={fullWidth ? 'w-full' : undefined}
      dataTestId={dataTestId}
    />
  );
};

export default RichNoteTag;
